import { kbToB } from '@/utils/util'

// 主办单位 居民身份证
export const IdentityCard = '2'

// 负责人 居民身份证
export const PrincipalIdentityCard = '2'

// 个人主体
export const individualSubject = '5'

// IP类型(ICP用)
export const IPV4Type = 0
export const IPV6Type = 1

// IP类型（IP用）
export const IPIPV4Type = 1
export const IPIPV6Type = 2

// 跨地区代码
export const TransRegionalCode = 990000

// 主办单位证件企业类型
export const unitNature = ['4', '1']

// 电子核验
export const electronicVerificationType = '2'
// 人工核验
export const manualVerificationType = '1'
// 工信部电子核验
export const gxbVerificationType = '3'

interface MainStatusType {
    // 审核通过
    passAudit: number
    // 审核退回
    sendBack: number
    // 等待管局审核
    awaitAudit: number
    // 等待上交
    waitDelivery: number
    // 等待核实
    awaitVerify: number
    // 等待确认
    awaitConfirm: number
}

// 备案流程状态
export const mainStatus: MainStatusType = {
    // 审核通过
    passAudit: 5,
    // 审核退回
    sendBack: 4,
    // 等待管局审核
    awaitAudit: 3,
    // 等待上交
    waitDelivery: 2,
    // 等待核实
    awaitVerify: 1,
    // 等待确认
    awaitConfirm: 0
}

interface SourceStatusType {
    // 域名迁移
    domainMigration: number
    // 网站迁移
    webMigration: number
    // 注销接入
    logoutAccess: number
    // 注销网站
    logoutWeb: number
    // 注销主体
    logoutSubject: number
    // 变更接入
    changeAccess: number
    // 变更网站
    changeWeb: number
    // 变更主体
    changeSubject: number
    // 变更备案
    changeFiling: number
    // 新增接入
    newAccess: number
    // 新增网站
    newWeb: number
    // 新增备案
    newFiling: number
}

// 备案来源
export const SourceStatus: SourceStatusType = {
    // 域名迁移
    domainMigration: 12,
    // 网站迁移
    webMigration: 11,
    // 注销接入
    logoutAccess: 10,
    // 注销网站
    logoutWeb: 9,
    // 注销主体
    logoutSubject: 8,
    // 变更接入
    changeAccess: 7,
    // 变更网站
    changeWeb: 6,
    // 变更主体
    changeSubject: 5,
    // 变更备案
    changeFiling: 4,
    // 新增接入
    newAccess: 3,
    // 新增网站
    newWeb: 2,
    // 新增备案
    newFiling: 1
}

// 上传证件最大尺寸(B)
export const certificateMaxSize = kbToB(200)

// 上传证件最小尺寸(B)
export const certificateMinSize = kbToB(100)

// 身份证最小尺寸
export const idCardMinSize = {
    width: 720,
    height: 1280
}

// 营业执照最小尺寸
export const businessLicenseMinSize = {
    width: 1500,
    height: 1100
}

// App平台其他运行类型
export const platformOtherType = '5'

// 普通用户角色
export const domesticConsumerRole = 1

// 管理员隐藏路由
export const adminHideRouterIds = [248]

// 默认应用服务类型
export const defaultApplicationServiceType = ['1']

// IP拆分类型
export const IpSplitType = 1
// IP合并类型
export const IpJoinType = 2

// 录入备案信息和未录入备案信息路由需相同，跳转 is_show 字段 控制显示隐藏即可
// 未录入备案信息用户路由
export const notEnteringUserRole = [
    {
        id: 248,
        pid: 0,
        type: 'C',
        name: '用户备案信息浏览',
        icon: 'el-icon-DocumentCopy',
        sort: 9999,
        perms: '',
        paths: 'filing_browsing',
        component: 'filing_browsing/index',
        selected: '/filing_browsing',
        params: '',
        is_cache: 1,
        is_show: 0,
        is_disable: 0,
        create_time: '2024-03-13 14:31:27',
        update_time: '2024-06-21 11:01:17'
    },
    {
        id: 173,
        pid: 0,
        type: 'M',
        name: 'ICP备案录入',
        icon: 'el-icon-Edit',
        sort: 1000,
        perms: '',
        paths: 'icp_entering',
        component: '',
        selected: '',
        params: '',
        is_cache: 0,
        is_show: 1,
        is_disable: 0,
        create_time: '2024-01-09 13:16:50',
        update_time: '2024-01-09 15:01:21',
        children: [
            {
                id: 174,
                pid: 173,
                type: 'C',
                name: '选择备案类型',
                icon: '',
                sort: 0,
                perms: '',
                paths: 'choose_filing_type',
                component: 'icp_entering/choose_filing_type/choose_filing_type',
                selected: '/icp_entering/choose_filing_type',
                params: '',
                is_cache: 1,
                is_show: 1,
                is_disable: 0,
                create_time: '2024-01-09 13:17:53',
                update_time: '2024-01-09 14:04:12'
            },
            {
                id: 175,
                pid: 173,
                type: 'C',
                name: '新增备案信息',
                icon: '',
                sort: 0,
                perms: '',
                paths: 'add_filing_info',
                component: 'icp_entering/add_filing_info/add_filing_info',
                selected: '/icp_entering/add_filing_info',
                params: '',
                is_cache: 1,
                is_show: 1,
                is_disable: 0,
                create_time: '2024-01-09 14:09:06',
                update_time: '2024-05-24 16:43:26'
            },
            {
                id: 176,
                pid: 173,
                type: 'C',
                name: '新增服务信息',
                icon: '',
                sort: 0,
                perms: '',
                paths: 'add_website_info',
                component: 'icp_entering/add_website_info/add_website_info',
                selected: '/icp_entering/add_website_info',
                params: '',
                is_cache: 1,
                is_show: 1,
                is_disable: 0,
                create_time: '2024-01-09 14:15:20',
                update_time: '2024-05-27 15:34:35'
            },
            {
                id: 177,
                pid: 173,
                type: 'C',
                name: '新增接入信息',
                icon: '',
                sort: 0,
                perms: '',
                paths: 'add_switch_info',
                component: 'icp_entering/add_switch_info/index',
                selected: '/icp_entering/add_switch_info',
                params: '',
                is_cache: 1,
                is_show: 1,
                is_disable: 0,
                create_time: '2024-01-09 14:18:45',
                update_time: '2024-01-09 14:18:45'
            },
            {
                id: 283,
                pid: 173,
                type: 'C',
                name: '新增接入',
                icon: '',
                sort: 0,
                perms: '',
                paths: 'add_access',
                component: 'icp_entering/add_access/add_access',
                selected: '/icp_entering/add_access',
                params: '',
                is_cache: 1,
                is_show: 0,
                is_disable: 0,
                create_time: '2024-05-23 18:15:54',
                update_time: '2024-05-24 17:01:28'
            }
        ]
    },
    // {
    //     id: 189,
    //     pid: 0,
    //     type: 'C',
    //     name: '备案管理列表',
    //     icon: 'local-icon-shuju_liuliang',
    //     sort: 970,
    //     perms: '',
    //     paths: 'filing_history',
    //     component: 'filing_history/index',
    //     selected: '/filing_history',
    //     params: '',
    //     is_cache: 1,
    //     is_show: 1,
    //     is_disable: 0,
    //     create_time: '2024-01-09 15:33:25',
    //     update_time: '2024-01-09 15:45:53'
    // },
    // 开始

    {
        id: 190,
        pid: 0,
        type: 'M',
        name: '备案管理列表',
        icon: 'local-icon-shuju_liuliang',
        sort: 1000,
        perms: '',
        paths: 'filing_new',
        component: '',
        selected: '',
        params: '',
        is_cache: 0,
        is_show: 1,
        is_disable: 0,
        create_time: '2024-01-09 13:16:50',
        update_time: '2024-01-09 15:01:21',
        children: [
            {
                id: 269,
                pid: 0,
                type: 'C',
                name: '等待确认材料',
                sort: 970,
                perms: '',
                paths: 'filing_history-queren',
                component: 'filing_new/filing_history-queren/index',
                selected: '/filing_new/filing_history-queren',
                params: '',
                is_cache: 1,
                is_show: 1,
                is_disable: 0,
                create_time: '2024-01-09 15:33:25',
                update_time: '2024-01-09 15:45:53'
            },
            {
                id: 270,
                pid: 0,
                type: 'C',
                name: '等待平台审核',
                sort: 970,
                perms: '',
                paths: 'filing_history-heshi',
                component: 'filing_new/filing_history-heshi/index',
                selected: '/filing_new/filing_history-heshi',
                params: '',
                is_cache: 1,
                is_show: 1,
                is_disable: 0,
                create_time: '2024-01-09 15:33:25',
                update_time: '2024-01-09 15:45:53'
            },

            {
                id: 271,
                pid: 0,
                type: 'C',
                name: '等待上交管局',
                sort: 970,
                perms: '',
                paths: 'filing_history-shangjiao',
                component: 'filing_new/filing_history-shangjiao/index',
                selected: '/filing_new/filing_history-shangjiao',
                params: '',
                is_cache: 1,
                is_show: 1,
                is_disable: 0,
                create_time: '2024-01-09 15:33:25',
                update_time: '2024-01-09 15:45:53'
            },

            {
                id: 272,
                pid: 0,
                type: 'C',
                name: '等待管局审核',
                sort: 970,
                perms: '',
                paths: 'filing_history-guanju',
                component: 'filing_new/filing_history-guanju/index',
                selected: '/filing_new/filing_history-guanju',
                params: '',
                is_cache: 1,
                is_show: 1,
                is_disable: 0,
                create_time: '2024-01-09 15:33:25',
                update_time: '2024-01-09 15:45:53'
            },
            {
                id: 274,
                pid: 0,
                type: 'C',
                name: '等待短信核验',
                sort: 970,
                perms: '',
                paths: 'filing_history-duanxin',
                component: 'filing_new/filing_history-duanxin/index',
                selected: '/filing_new/filing_history-duanxin',
                params: '',
                is_cache: 1,
                is_show: 1,
                is_disable: 0,
                create_time: '2024-01-09 15:33:25',
                update_time: '2024-01-09 15:45:53'
            },
            {
                id: 275,
                pid: 0,
                type: 'C',
                name: '等待管局人工审核',
                sort: 970,
                perms: '',
                paths: 'filing_history-rengong',
                component: 'filing_new/filing_history-rengong/index',
                selected: '/filing_new/filing_history-rengong',
                params: '',
                is_cache: 1,
                is_show: 1,
                is_disable: 0,
                create_time: '2024-01-09 15:33:25',
                update_time: '2024-01-09 15:45:53'
            },
            {
                id: 276,
                pid: 0,
                type: 'C',
                name: '管局审核通过',
                sort: 970,
                perms: '',
                paths: 'filing_history-tongguo',
                component: 'filing_new/filing_history-tongguo/index',
                selected: '/filing_new/filing_history-tongguo',
                params: '',
                is_cache: 1,
                is_show: 1,
                is_disable: 0,
                create_time: '2024-01-09 15:33:25',
                update_time: '2024-01-09 15:45:53'
            },

            {
                id: 277,
                pid: 0,
                type: 'C',
                name: '管局审核退回',
                sort: 970,
                perms: '',
                paths: 'filing_history-tuihui',
                component: 'filing_new/filing_history-tuihui/index',
                selected: '/filing_new/filing_history-tuihui',
                params: '',
                is_cache: 1,
                is_show: 1,
                is_disable: 0,
                create_time: '2024-01-09 15:33:25',
                update_time: '2024-01-09 15:45:53'
            },
            {
                id: 311,
                pid: 178,
                type: 'C',
                name: '申请注销服务',
                icon: '',
                sort: 88,
                perms: '',
                paths: 'applay_cancel_service',
                component: 'icp_filing_admin/applay_cancel_service/index',
                selected: '',
                params: '',
                is_cache: 1,
                is_show: 1,
                is_disable: 0,
                create_time: '2024-08-02 11:09:27',
                update_time: '2024-09-12 09:24:07'
            },
            {
                id: 186,
                pid: 178,
                type: 'C',
                name: '注销服务列表',
                icon: '',
                sort: 82,
                perms: '',
                paths: 'applay_cancel_cut_in',
                component: 'icp_filing_admin/applay_cancel_cut_in/index',
                selected: '',
                params: '',
                is_cache: 1,
                is_show: 1,
                is_disable: 0,
                create_time: '2024-01-09 15:11:37',
                update_time: '2024-12-27 16:56:33'
            },
            {
                id: 318,
                pid: 178,
                type: 'C',
                name: '注销主体列表',
                icon: '',
                sort: 0,
                perms: '',
                paths: 'logout_filing',
                component: 'icp_filing_admin/logout_filing/index',
                selected: '',
                params: '',
                is_cache: 1,
                is_show: 1,
                is_disable: 0,
                create_time: '2024-12-27 13:26:41',
                update_time: '2024-12-27 13:26:41'
            }
        ]
    },
    {
        id: 188,
        pid: 0,
        type: 'C',
        name: '所有备案查询',
        icon: 'el-icon-Search',
        sort: 990,
        perms: '',
        paths: 'icp_filing_find',
        component: 'icp_filing_find/index',
        selected: '/icp_filing_find',
        params: '',
        is_cache: 1,
        is_show: 1,
        is_disable: 0,
        create_time: '2024-01-09 15:31:25',
        update_time: '2024-01-09 15:32:09'
    },
    // 结束
    {
        id: 203,
        pid: 0,
        type: 'C',
        name: '备案状态查询',
        icon: 'el-icon-Pointer',
        sort: 930,
        perms: '',
        paths: 'filing_status_find',
        component: 'filing_status_find/index',
        selected: '/filing_status_find',
        params: '',
        is_cache: 0,
        is_show: 1,
        is_disable: 0,
        create_time: '2024-01-09 16:42:31',
        update_time: '2024-05-16 11:00:34'
    },

    {
        id: 241,
        pid: 0,
        type: 'C',
        name: '上传材料',
        icon: '',
        sort: 0,
        perms: '',
        paths: 'upload_materials',
        component: 'upload_materials/index',
        selected: '/upload_materials',
        params: '',
        is_cache: 0,
        is_show: 0,
        is_disable: 0,
        create_time: '2024-02-26 17:42:25',
        update_time: '2024-06-21 10:11:53'
    },
    {
        id: 242,
        pid: 0,
        type: 'C',
        name: '修改服务',
        icon: '',
        sort: 0,
        perms: '',
        paths: 'change_web',
        component: 'change_web/index',
        selected: '/change_web',
        params: '',
        is_cache: 1,
        is_show: 0,
        is_disable: 0,
        create_time: '2024-03-06 15:31:18',
        update_time: '2024-06-19 10:42:02'
    },
    {
        id: 243,
        pid: 0,
        type: 'C',
        name: '修改主体',
        icon: '',
        sort: 0,
        perms: '',
        paths: 'add_change_filing',
        component: 'add_change_filing/index',
        selected: '/add_change_filing',
        params: '',
        is_cache: 1,
        is_show: 0,
        is_disable: 0,
        create_time: '2024-03-07 14:25:03',
        update_time: '2024-06-19 10:42:41'
    },
    {
        id: 244,
        pid: 0,
        type: 'C',
        name: '新增服务',
        icon: '',
        sort: 0,
        perms: '',
        paths: 'add_web',
        component: 'add_web/index',
        selected: '/add_web',
        params: '',
        is_cache: 1,
        is_show: 0,
        is_disable: 0,
        create_time: '2024-03-07 17:26:26',
        update_time: '2024-06-11 17:23:17'
    },
    {
        id: 302,
        pid: 0,
        type: 'C',
        name: '修改接入服务',
        icon: '',
        sort: 0,
        perms: '',
        paths: '/change_access_service',
        component: 'change_access_service/index',
        selected: '/change_access_service',
        params: '',
        is_cache: 1,
        is_show: 0,
        is_disable: 0,
        create_time: '2024-06-19 10:44:25',
        update_time: '2024-06-19 10:45:01'
    },
    {
        id: 303,
        pid: 0,
        type: 'C',
        name: '修改接入主体',
        icon: '',
        sort: 0,
        perms: '',
        paths: '/change_access_main',
        component: 'change_access_main/index',
        selected: '/change_access_main',
        params: '',
        is_cache: 1,
        is_show: 0,
        is_disable: 0,
        create_time: '2024-06-19 11:23:17',
        update_time: '2024-06-19 11:23:17'
    },
    {
        id: 304,
        pid: 0,
        type: 'C',
        name: '变更接入',
        icon: '',
        sort: 0,
        perms: '',
        paths: '/change_access',
        component: 'change_access/index',
        selected: '/change_access',
        params: '',
        is_cache: 1,
        is_show: 0,
        is_disable: 0,
        create_time: '2024-06-19 16:43:32',
        update_time: '2024-06-19 16:43:32'
    },
    {
        id: 305,
        pid: 0,
        type: 'C',
        name: '修改变更服务',
        icon: '',
        sort: 0,
        perms: '',
        paths: 'modify_hange_access',
        component: 'modify_hange_access/index',
        selected: '/modify_hange_access',
        params: '',
        is_cache: 1,
        is_show: 0,
        is_disable: 0,
        create_time: '2024-06-19 18:03:19',
        update_time: '2024-06-19 18:03:19'
    },
    {
        id: 306,
        pid: 0,
        type: 'C',
        name: '变更主体',
        icon: '',
        sort: 0,
        perms: '',
        paths: 'change_filing_subject',
        component: 'change_filing_subject/index',
        selected: '/change_filing_subject',
        params: '',
        is_cache: 1,
        is_show: 0,
        is_disable: 0,
        create_time: '2024-06-20 10:02:14',
        update_time: '2024-06-20 10:02:14'
    },
    {
        id: 307,
        pid: 0,
        type: 'C',
        name: '变更服务',
        icon: '',
        sort: 0,
        perms: '',
        paths: '/change_filing_website',
        component: 'change_filing_website/index',
        selected: '/change_filing_website',
        params: '',
        is_cache: 1,
        is_show: 0,
        is_disable: 0,
        create_time: '2024-06-20 11:06:36',
        update_time: '2024-06-20 11:06:36'
    },
    {
        id: 197,
        pid: 0,
        type: 'M',
        name: '备案核查管理',
        icon: 'el-icon-View',
        sort: 940,
        perms: '',
        paths: 'examine_admin',
        component: '',
        selected: '',
        params: '',
        is_cache: 0,
        is_show: 1,
        is_disable: 0,
        create_time: '2024-01-09 16:12:00',
        update_time: '2025-07-04 10:16:43',
        children: [
            {
                id: 322,
                pid: 197,
                type: 'C',
                name: '主体核查',
                icon: '',
                sort: 0,
                perms: '',
                paths: 'main_examine',
                component: 'examine_admin/main_examine/index',
                selected: '',
                params: '',
                is_cache: 1,
                is_show: 1,
                is_disable: 0,
                create_time: '2025-07-04 10:33:03',
                update_time: '2025-07-04 10:48:14'
            },
            {
                id: 323,
                pid: 197,
                type: 'C',
                name: '服务核查',
                icon: '',
                sort: 0,
                perms: '',
                paths: 'server_examine',
                component: 'examine_admin/server_examine/index',
                selected: '',
                params: '',
                is_cache: 0,
                is_show: 1,
                is_disable: 0,
                create_time: '2025-07-04 10:33:59',
                update_time: '2025-07-04 10:48:22'
            }
        ]
    },
    {
        id: 336,
        pid: 0,
        type: 'C',
        name: '变更备案',
        icon: '',
        sort: 0,
        perms: '',
        paths: 'change_filing_filing',
        component: 'change_filing_filing/index',
        selected: '',
        params: '',
        is_cache: 1,
        is_show: 0,
        is_disable: 0,
        create_time: '2025-07-29 10:48:26',
        update_time: '2025-07-29 10:48:26'
    }
]

export const UserHome = '/icp_entering/choose_filing_type'
export const AdminHome = '/home'

// 主体服务列表中的注销状态
export const LogoffStatusInactive = 0 // 未注销
export const LogoffStatusUnderway = 1 // 注销中
export const LogoffStatusSuccess = 2 // 已注销
export const LogoffStatusFail = 3 // 注销失败
